import "./MeetTheFounders.module.css";
import Header from "@/reusable_sections/Header";
import OurMission from "./sections/OurMission";
import Founders from "./sections/Founders";
import GetInTouch from "./sections/GetInTouch";
import Footer from "@/reusable_sections/Footer";
export default function MeetTheFoundersPage() {
  return <div>
      <Header />
      <OurMission />
      <Founders />
      <GetInTouch />
      <Footer />
    </div>;
}